<template>
    <div class='container-fluid padding-0' style="margin-top: -15px">
        <div class="row">
            <div class="col-md-4">
                <generator-steps :active-step="activeStep" :show-finish-button="showFinishButton"> </generator-steps>
            </div>
            <div class="col-md-8">
                <slot> </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import GeneratorSteps from './GeneratorSteps';

    export default {
        name: "document-generator",

        components: {
            GeneratorSteps
        },

        props: ['activeStep', 'showFinishButton'],

        data() {
            return {
                loading: true
            }
        }
    }
</script>

<style scoped>

</style>